import React, { Component } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { message, Spin, Radio, Space, Select } from "antd";
import Bridge from "../../utils/Bridge";
import { logEvent } from "../../utils/analytics";

const { Option } = Select;

export default class AresScore extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      speech: "",
      salvation: "",
      swallowing: "",
      handwriting: "",
      cutting_food_a: "",
      cutting_food_b: "",
      dressing_and_hygiene: "",
      turning_in_bed: "",
      walking: "",
      climbing_stairs: "",
      dyspnea: "",
      orthopnea: "",
      respiratory_insufficiency: "",

      at_rest_in_chair: "",
      lying_in_flat_bed: "",
      while_eating: "",
      getting_dressed: "",
      combining_hair: "",
      stading_up_from_chair: "",
      walking_100_feet_at_own_pace: "",
      walking_up_1_flight: "",
      how_much_fatigue_limit: "",
      how_often_do_wake_up_headache: "",
      how_often_fall_asleep_while_engaging_social: "",
      how_often_awaken_at_night: "",

      option_list: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      radio_buttons: [
        {
          label: "never",
          value: "0",
        },
        {
          label: "once or twice a month",
          value: "3",
        },
        { label: "once or twice a week", value: "6" },
        { label: "almost every day", value: "10" },
      ],
    };
  }
  save_areas_score = () => {
    if (
      this.state.at_rest_in_chair === "" &&
      this.state.at_rest_in_chair !== 0
    ) {
      message.warning("Please select value of 'At rest in a chair' field");
      return;
    }
    if (
      this.state.lying_in_flat_bed === "" &&
      this.state.lying_in_flat_bed !== 0
    ) {
      message.warning("Please select value of 'Lying flat in bed' field");
      return;
    }
    if (this.state.while_eating === "" && this.state.while_eating !== 0) {
      message.warning("Please select value of 'While eating' field");
      return;
    }
    if (this.state.combining_hair === "" && this.state.combining_hair !== 0) {
      message.warning("Please select value of 'Combing hair or shaving' field");
      return;
    }
    if (this.state.getting_dressed === "" && this.state.getting_dressed !== 0) {
      message.warning("Please select value of 'Getting dressed' field");
      return;
    }
    if (
      this.state.stading_up_from_chair === "" &&
      this.state.stading_up_from_chair !== 0
    ) {
      message.warning(
        "Please select value of 'Standing up from a chair or bed' field"
      );
      return;
    }
    if (
      this.state.walking_100_feet_at_own_pace === "" &&
      this.state.walking_100_feet_at_own_pace !== 0
    ) {
      message.warning(
        "Please select value of 'Walking 100 feet at own pace' field"
      );
      return;
    }
    if (
      this.state.walking_up_1_flight === "" &&
      this.state.walking_up_1_flight !== 0
    ) {
      message.warning(
        "Please select value of 'Walking up 1 flight of stairs' field"
      );
      return;
    }
    if (
      this.state.how_much_fatigue_limit === "" &&
      this.state.how_much_fatigue_limit !== 0
    ) {
      message.warning(
        "Please select value of 'How much does faigue limit your activity?' field"
      );
      return;
    }
    if (
      this.state.how_often_do_wake_up_headache === "" &&
      this.state.how_often_do_wake_up_headache !== 0
    ) {
      message.warning(
        "Please select value of 'How often do you wake up with a headache?' field"
      );
      return;
    }
    if (
      this.state.how_often_fall_asleep_while_engaging_social === "" &&
      this.state.how_often_fall_asleep_while_engaging_social !== 0
    ) {
      message.warning(
        "Please select value of 'How often do you fail asleep while engaging in usual social ativities?' field"
      );
      return;
    }
    let total =
      Number(this.state.at_rest_in_chair) +
      Number(this.state.lying_in_flat_bed) +
      Number(this.state.while_eating) +
      Number(this.state.getting_dressed) +
      Number(this.state.combining_hair) +
      Number(this.state.stading_up_from_chair) +
      Number(this.state.walking_100_feet_at_own_pace) +
      Number(this.state.walking_up_1_flight) +
      Number(this.state.how_much_fatigue_limit) +
      Number(this.state.how_often_do_wake_up_headache) +
      Number(this.state.how_often_fall_asleep_while_engaging_social) +
      Number(this.state.how_often_awaken_at_night);

    let params = {
      at_rest_in_chair: this.state.at_rest_in_chair,
      lying_in_flat_bed: this.state.lying_in_flat_bed,
      while_eating: this.state.while_eating,
      getting_dressed: this.state.getting_dressed,
      combining_hair: this.state.combining_hair,
      stading_up_from_chair: this.state.stading_up_from_chair,
      walking_100_feet_at_own_pace: this.state.walking_100_feet_at_own_pace,
      walking_up_1_flight: this.state.walking_up_1_flight,
      how_much_fatigue_limit: this.state.how_much_fatigue_limit,
      how_often_do_wake_up_headache: this.state.how_often_do_wake_up_headache,
      how_often_fall_asleep_while_engaging_social:
        this.state.how_often_fall_asleep_while_engaging_social,
      how_often_awaken_at_night: this.state.how_often_awaken_at_night,
      eals_id: localStorage.getItem("ap_eals_id"),
      total_score: total,
    };

    this.setState({ loading: true });
    Bridge.ares_score
      .save(params)
      .then((response) => {
        if (response.data.status == "1") {
          logEvent("form_submitted", { form_name: "ares" });
          message.success(response.data.message);
          this.setState(
            {
              at_rest_in_chair: "",
              lying_in_flat_bed: "",
              while_eating: "",
              getting_dressed: "",
              combining_hair: "",
              stading_up_from_chair: "",
              walking_100_feet_at_own_pace: "",
              walking_up_1_flight: "",
              how_much_fatigue_limit: "",
              how_often_do_wake_up_headache: "",
              how_often_fall_asleep_while_engaging_social: "",
              how_often_awaken_at_night: "",
              loading: false,
            },
            () => {
              setTimeout(() => {
                window.location.assign("/dashboard");
              }, 2000);
            }
          );
        } else {
          message.warning(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.error("Please try again!!");
        this.setState({ loading: false });
      });
  };
  render() {
    return (
      <div>
        <Header />
        <div className="main-content demographics-section-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-11 m-auto">
                <Spin spinning={this.state.loading}>
                  <div className="demographic-single-section">
                    <a
                      href="/dashboard"
                      style={{ width: 95 }}
                      className="back-arrow"
                    >
                      <box-icon
                        name="chevron-left"
                        color="#fff"
                        style={{ position: "relative", top: 1 }}
                      ></box-icon>
                      Back
                    </a>
                    <div>
                      <div className="header">
                        <h3>ADD ARES Score</h3>
                        <div className="white-block"></div>
                      </div>
                      <Spin spinning={this.state.loading}>
                        <div className="form-fields">
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              At rest in a chair{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Select
                              onChange={(value) =>
                                this.setState({ at_rest_in_chair: value })
                              }
                              value={this.state.at_rest_in_chair}
                              style={{
                                width: "100%",
                                height: 55,
                                maxWidth: 500,
                              }}
                            >
                              <Option value="">Select</Option>
                              {this.state.option_list.map((item, index) => {
                                return (
                                  <Option value={item} key={index}>
                                    {item}
                                  </Option>
                                );
                              })}
                            </Select>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              Lying flat in bed{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Select
                              onChange={(value) =>
                                this.setState({ lying_in_flat_bed: value })
                              }
                              value={this.state.lying_in_flat_bed}
                              style={{
                                width: "100%",
                                height: 55,
                                maxWidth: 500,
                              }}
                            >
                              <Option value="">Select</Option>
                              {this.state.option_list.map((item, index) => {
                                return (
                                  <Option value={item} key={index}>
                                    {item}
                                  </Option>
                                );
                              })}
                            </Select>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              While eating{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Select
                              onChange={(value) =>
                                this.setState({ while_eating: value })
                              }
                              value={this.state.while_eating}
                              style={{
                                width: "100%",
                                height: 55,
                                maxWidth: 500,
                              }}
                            >
                              <Option value="">Select</Option>
                              {this.state.option_list.map((item, index) => {
                                return (
                                  <Option value={item} key={index}>
                                    {item}
                                  </Option>
                                );
                              })}
                            </Select>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              Combing hair or shaving{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Select
                              onChange={(value) =>
                                this.setState({ combining_hair: value })
                              }
                              value={this.state.combining_hair}
                              style={{
                                width: "100%",
                                height: 55,
                                maxWidth: 500,
                              }}
                            >
                              <Option value="">Select</Option>
                              {this.state.option_list.map((item, index) => {
                                return (
                                  <Option value={item} key={index}>
                                    {item}
                                  </Option>
                                );
                              })}
                            </Select>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              Getting dressed{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Select
                              onChange={(value) =>
                                this.setState({ getting_dressed: value })
                              }
                              value={this.state.getting_dressed}
                              style={{
                                width: "100%",
                                height: 55,
                                maxWidth: 500,
                              }}
                            >
                              <Option value="">Select</Option>
                              {this.state.option_list.map((item, index) => {
                                return (
                                  <Option value={item} key={index}>
                                    {item}
                                  </Option>
                                );
                              })}
                            </Select>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              Standing up from a chair or bed{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Select
                              onChange={(value) =>
                                this.setState({ stading_up_from_chair: value })
                              }
                              value={this.state.stading_up_from_chair}
                              style={{
                                width: "100%",
                                height: 55,
                                maxWidth: 500,
                              }}
                            >
                              <Option value="">Select</Option>
                              {this.state.option_list.map((item, index) => {
                                return (
                                  <Option value={item} key={index}>
                                    {item}
                                  </Option>
                                );
                              })}
                            </Select>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              Walking 100 feet at own pace{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Select
                              onChange={(value) =>
                                this.setState({
                                  walking_100_feet_at_own_pace: value,
                                })
                              }
                              value={this.state.walking_100_feet_at_own_pace}
                              style={{
                                width: "100%",
                                height: 55,
                                maxWidth: 500,
                              }}
                            >
                              <Option value="">Select</Option>
                              {this.state.option_list.map((item, index) => {
                                return (
                                  <Option value={item} key={index}>
                                    {item}
                                  </Option>
                                );
                              })}
                            </Select>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              Walking up 1 flight of stairs{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Select
                              onChange={(value) =>
                                this.setState({
                                  walking_up_1_flight: value,
                                })
                              }
                              value={this.state.walking_up_1_flight}
                              style={{
                                width: "100%",
                                height: 55,
                                maxWidth: 500,
                              }}
                            >
                              <Option value="">Select</Option>
                              {this.state.option_list.map((item, index) => {
                                return (
                                  <Option value={item} key={index}>
                                    {item}
                                  </Option>
                                );
                              })}
                            </Select>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              How much does fatigue limit your activity{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Select
                              onChange={(value) =>
                                this.setState({
                                  how_much_fatigue_limit: value,
                                })
                              }
                              value={this.state.how_much_fatigue_limit}
                              style={{
                                width: "100%",
                                height: 55,
                                maxWidth: 500,
                              }}
                            >
                              <Option value="">Select</Option>
                              {this.state.option_list.map((item, index) => {
                                return (
                                  <Option value={item} key={index}>
                                    {item}
                                  </Option>
                                );
                              })}
                            </Select>
                          </div>
                          <div className="form-group">
                            <label className="input-heading">
                              How often do you wake up with a headache?{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  how_often_do_wake_up_headache: e.target.value,
                                })
                              }
                              value={this.state.how_often_do_wake_up_headache}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.radio_buttons.map((item, index) => {
                                  return (
                                    <Radio value={item.value} key={index}>
                                      {item.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="input-heading">
                              How often do you fall asleep while engaging in
                              usual social activities?{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  how_often_fall_asleep_while_engaging_social:
                                    e.target.value,
                                })
                              }
                              value={
                                this.state
                                  .how_often_fall_asleep_while_engaging_social
                              }
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.radio_buttons.map((item, index) => {
                                  return (
                                    <Radio value={item.value} key={index}>
                                      {item.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              How often do you awaken at night
                            </label>
                            <br />
                            <Select
                              onChange={(value) =>
                                this.setState({
                                  how_often_awaken_at_night: value,
                                })
                              }
                              value={this.state.how_often_awaken_at_night}
                              style={{
                                width: "100%",
                                height: 55,
                                maxWidth: 500,
                              }}
                            >
                              <Option value="">Select</Option>
                              {this.state.option_list.map((item, index) => {
                                return (
                                  <Option value={item} key={index}>
                                    {item}
                                  </Option>
                                );
                              })}
                            </Select>
                          </div>
                          <div className="d-flex mt-5">
                            <button
                              className="submit-button ml-2"
                              style={{
                                marginLeft: 0,
                                padding: "9px 15px 10px 20px",
                              }}
                              onClick={() => this.save_areas_score()}
                            >
                              Save{" "}
                              <box-icon
                                name="chevron-right"
                                color="#fff"
                                style={{ position: "relative", top: 1 }}
                              ></box-icon>
                            </button>
                          </div>
                        </div>
                      </Spin>
                    </div>
                  </div>
                </Spin>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
